module.exports = __webpack_public_path__ + "static/media/image.3e4ccd60.png";